import { render, staticRenderFns } from "./PacienteList.vue?vue&type=template&id=6038f5b2"
import script from "./PacienteList.vue?vue&type=script&lang=js"
export * from "./PacienteList.vue?vue&type=script&lang=js"
import style0 from "./PacienteList.vue?vue&type=style&index=0&id=6038f5b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/msuarez/PycharmProjects/terrada-front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports